import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=5dccaf86&"
import script from "./SearchCustomer.vue?vue&type=script&lang=ts&"
export * from "./SearchCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports